import * as TaxonsService from '../services/taxons'
import { TaxonGroup } from '../../typings/base'
import { getLocale } from '../helpers/api'

export const ACTIONS = {
  GET_TAXONS_REQUEST: 'GET_TAXONS_REQUEST',
  GET_TAXONS_SUCCESS: 'GET_TAXONS_SUCCESS',
  GET_TAXONS_FAILURE: 'GET_TAXONS_FAILURE',
  GET_TAXONS_ATTRIBUTES_REQUEST: 'GET_TAXONS_ATTRIBUTES_REQUEST',
  GET_TAXONS_ATTRIBUTES_SUCCESS: 'GET_TAXONS_ATTRIBUTES_SUCCESS',
  GET_TAXONS_ATTRIBUTES_FAILURE: 'GET_TAXONS_ATTRIBUTES_FAILURE',
  GET_TAXONS_SIZES_REQUEST: 'GET_TAXONS_SIZES_REQUEST',
  GET_TAXONS_SIZES_SUCCESS: 'GET_TAXONS_SIZES_SUCCESS',
  GET_TAXONS_SIZES_FAILURE: 'GET_TAXONS_SIZES_FAILURE',
  GET_ATTRIBUTE_VALUES_REQUEST: 'GET_ATTRIBUTE_VALUES_REQUEST',
  GET_ATTRIBUTE_VALUES_SUCCESS: 'GET_ATTRIBUTE_VALUES_SUCCESS',
  GET_ATTRIBUTE_VALUES_FAILURE: 'GET_ATTRIBUTE_VALUES_FAILURE',
}

export const GET_TAXONS_REQUEST = () => ({
  type: ACTIONS.GET_TAXONS_REQUEST,
})

export const GET_TAXONS_SUCCESS = (taxons: TaxonGroup, locale: string) => ({
  type: ACTIONS.GET_TAXONS_SUCCESS,
  taxons,
  locale,
})

export const GET_TAXONS_FAILURE = (err) => ({
  type: ACTIONS.GET_TAXONS_FAILURE,
  err,
})

export function getTaxons() {
  const locale = getLocale()
  return (dispatch, getState) => {
    // check if locale is different from locale in redux. if not, return
    const state = getState()
    if (state.taxons.locale === locale) {
      return
    }
    dispatch(GET_TAXONS_REQUEST())
    return TaxonsService.getTaxons().then(
      (response) => dispatch(GET_TAXONS_SUCCESS(response, locale)),
      (err) => dispatch(GET_TAXONS_FAILURE(err))
    )
  }
}

export const GET_TAXONS_ATTRIBUTES_REQUEST = () => ({
  type: ACTIONS.GET_TAXONS_ATTRIBUTES_REQUEST,
})

export const GET_TAXONS_ATTRIBUTES_SUCCESS = (attributes, slug) => ({
  type: ACTIONS.GET_TAXONS_ATTRIBUTES_SUCCESS,
  attributes,
  slug,
})

export const GET_TAXONS_ATTRIBUTES_FAILURE = (err) => ({
  type: ACTIONS.GET_TAXONS_ATTRIBUTES_FAILURE,
  err,
})

export function getTaxonsAttributes(taxonSlug) {
  return (dispatch) => {
    dispatch(GET_TAXONS_ATTRIBUTES_REQUEST())
    return TaxonsService.getTaxonsAttributes(taxonSlug).then(
      (response) =>
        dispatch(GET_TAXONS_ATTRIBUTES_SUCCESS(response, taxonSlug)),
      (err) => dispatch(GET_TAXONS_ATTRIBUTES_FAILURE(err))
    )
  }
}

export const GET_TAXONS_SIZES_REQUEST = () => ({
  type: ACTIONS.GET_TAXONS_SIZES_REQUEST,
})

export const GET_TAXONS_SIZES_SUCCESS = (sizes, code) => ({
  type: ACTIONS.GET_TAXONS_SIZES_SUCCESS,
  sizes,
  code,
})

export const GET_TAXONS_SIZES_FAILURE = (err) => ({
  type: ACTIONS.GET_TAXONS_SIZES_FAILURE,
  err,
})

export function getTaxonsSizes(taxonCode) {
  return (dispatch) => {
    dispatch(GET_TAXONS_SIZES_REQUEST())
    return TaxonsService.getTaxonsSizes(taxonCode).then(
      (response) => dispatch(GET_TAXONS_SIZES_SUCCESS(response, taxonCode)),
      (err) => dispatch(GET_TAXONS_SIZES_FAILURE(err))
    )
  }
}

export const GET_ATTRIBUTE_VALUES_REQUEST = (attributeCode: string) => ({
  type: ACTIONS.GET_ATTRIBUTE_VALUES_REQUEST,
  attributeCode,
})

export const GET_ATTRIBUTE_VALUES_SUCCESS = (
  attributeCode: string,
  values: any[],
  locale: string
) => ({
  type: ACTIONS.GET_ATTRIBUTE_VALUES_SUCCESS,
  attributeCode,
  values,
  locale,
})

export const GET_ATTRIBUTE_VALUES_FAILURE = (
  attributeCode: string,
  err: any
) => ({
  type: ACTIONS.GET_ATTRIBUTE_VALUES_FAILURE,
  attributeCode,
  err,
})

export function getAttributeValues(attributeCode: string) {
  const locale = getLocale()
  return (dispatch, getState) => {
    // check if we already have values for this attribute and locale
    const state = getState()
    const existingValues = state.taxons.attributeValues?.[attributeCode]
    if (existingValues && existingValues.locale === locale) {
      return Promise.resolve(existingValues.values)
    }

    dispatch(GET_ATTRIBUTE_VALUES_REQUEST(attributeCode))
    return TaxonsService.getProductAttributeByCode(attributeCode).then(
      (response) =>
        dispatch(GET_ATTRIBUTE_VALUES_SUCCESS(attributeCode, response, locale)),
      (err) => dispatch(GET_ATTRIBUTE_VALUES_FAILURE(attributeCode, err))
    )
  }
}
